export function specificRound(value: number, digitsAfterDot: number) {
  const divider = 10 ** digitsAfterDot
  return Math.round((value + Number.EPSILON) * divider) / divider
}

export function getStep(value: string): number {
  const numberValue = Number(value)

  if (numberValue > 100) return 100

  if (numberValue > 10) return 1

  if (numberValue > 1) return 0.1

  if (numberValue > 0.1) return 0.01

  if (numberValue > 0.01) return 0.001

  return 0.0001
}
